
import { defineComponent } from "vue";
import router from "@/router";
import {
  GetMetricData,
  GetMetric,
  SummaryTitleByQuarter,
  GetHighlight,
  ChangeOverTime,
  SourceURL,
  NumberWithCommas,
  GetMoneyFormat,
} from "@/utils";
import Spinner from "@/components/Spinner.vue";
import MetricGrid from "@/components/MetricGrid.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import ChartOptions from "@/types/chartOptions";
import FilterTabs from "@/components/Chart/FilterTabs.vue";
import MetricTitle from "@/components/MetricTitle.vue";
import SectionTitle from "@/components/SectionTitle.vue";
import MetricStat from "@/components/MetricStat.vue";
import MetricSource from "@/components/MetricSource.vue";
import MetricHighlight from "@/components/MetricHighlight.vue";
import Metric from "@/types/metric";

export default defineComponent({
  data() {
    return {
      data: [],
      selectedData: [],
      metric: {} as Metric,
      summaryDate: new Date(),
      latestNumbers: "",
      quarterChange: "",
      yearChange: "",
      highlight: "",
      filterOptions: [1, 5, 10, 0],

      //Chart setup
      options: new ChartOptions(),
      dataLabels: ["MI GDP"],
      dataProps: ["real_gdp__millions_of_chained_2012_dollars"],
    };
  },
  components: {
    Spinner,
    LineChart,
    MetricGrid,
    MetricTitle,
    SectionTitle,
    FilterTabs,
    MetricStat,
    MetricSource,
    MetricHighlight,
  },
  methods: {
    handleFilter(option: any) {
      this.limitData(option);
    },
    limitData(years: number) {
      /* This is going to be custom for each metric, you need to cin some cases 
        convert the lable to a date. Then limit the date to the intended range */

      if (years == 0) {
        this.selectedData = this.data;
      } else {
        let count = -1 * (4 * years);
        this.selectedData = this.data.slice(count);
      }
    },
    summaryTitle() {
      return SummaryTitleByQuarter(this.summaryDate);
    },
    sourceUrl() {
      return SourceURL(this.metric);
    },
  },
  async beforeMount() {
    //@ts-ignore
    const topic = router.currentRoute.value.name; // Get which metric by the route
    this.data = await GetMetricData(topic); // Get raw data from Socrata
    this.metric = GetMetric(topic); // Get metric configuration
    this.selectedData = this.data; // initialize this to "lifetime" and update this variable when a range is selected

    //Add custom chart options
    this.options.scales.yAxis.ticks.callback = (label: any) => {
      return NumberWithCommas(Number(label) / 1000) + "K";
    };

    // Get summary data and hightlights
    const lastItem: any = this.data[this.data.length - 1];
    this.summaryDate = lastItem.date;
    this.latestNumbers = NumberWithCommas(lastItem[this.dataProps[0]]);


    // Formula as quoted by BEA https://www.bea.gov/help/faq/463
    // As noted by client  [(current qtr GDP/previous qtr GDP)^4]-1 for quartlery change


    const currQuarter = this.data[this.data.length - 1][this.dataProps[0]];
    const prevQuarter = this.data[this.data.length - 2][this.dataProps[0]];
    const prevYearQuater = this.data[this.data.length - 5][this.dataProps[0]];

    this.quarterChange = `${(((Math.pow((currQuarter / prevQuarter), (4/1)))  - 1) * 100).toFixed(1)}%`;
    this.yearChange = `${(((Math.pow((currQuarter / prevYearQuater), (4/4)))  - 1) * 100).toFixed(1)}%`;

    this.highlight = GetHighlight(this.data);
  },
});
